import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTags } from '../../building/store/tag.selector';
import { Observable } from 'rxjs';
import { Tag } from '../../building/model/tag.model';
import { replaceBuildingsSelection } from '../../building/store/buildings.action';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { deleteTag } from 'src/app/building/store/tag.action';
import { WidgetComponent } from '../widget/widget.component';
import { MatIcon } from '@angular/material/icon';
import { MatChipListbox } from '@angular/material/chips';
import { TagComponent } from '../../shared/components/chips/tag/tag.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-tags-widget',
  template: `
    <sibat-widget title="{{ 'cockpit.tags' | transloco }}">
      <mat-icon widget-icon>sell</mat-icon>
      <div widget-content class="content">
        @if (tags$ | async; as tags) { @if (tags.length) {
        <mat-chip-listbox>
          @for (tag of tags; track tag) {
          <sibat-tag [name]="tag.name" (selected)="onSelection(tag)" (delete)="onDelete(tag)"></sibat-tag>
          }
        </mat-chip-listbox>
        } @else {
        <p>{{ 'cockpit.noTags' | transloco }}</p>
        } } @else {
        <p>{{ 'cockpit.noTags' | transloco }}</p>
        }
      </div>
    </sibat-widget>
  `,
  styleUrls: ['tags-widget.component.scss'],
  imports: [WidgetComponent, MatIcon, MatChipListbox, TagComponent, TranslocoPipe, AsyncPipe],
})
export class TagsWidgetComponent implements OnInit {
  tags$: Observable<Tag[]>;

  constructor(private store: Store, private dialogService: DialogService, private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.tags$ = this.store.select(selectTags);
  }

  onSelection(tag: Tag) {
    this.store.dispatch(replaceBuildingsSelection({ buildingIds: tag.buildingIds }));
  }

  async onDelete(tag: Tag): Promise<void> {
    const label = this.translocoService.translate('building.tags.confirmRemove', { tag: tag.name });
    const result = await this.dialogService.requestConfirmation(label);
    if (result) {
      this.store.dispatch(deleteTag({ tag }));
    }
  }
}
